import { onBeforeUnmount, shallowRef, watch } from 'vue';

/**
 * Tracks the inner (client) width of an element via ResizeObserver.
 *
 * @param {import('vue').Ref<HTMLElement|null>} elementRef
 */
export function useElementWidth(elementRef) {
  const width = shallowRef(0);
  let observer = null;

  const disconnect = () => {
    observer?.disconnect();
    observer = null;
  };

  watch(
    elementRef,
    (element) => {
      disconnect();
      if (!element) {
        return;
      }

      width.value = element.clientWidth;
      observer = new ResizeObserver(() => {
        width.value = element.clientWidth;
      });
      observer.observe(element);
    },
    { immediate: true, flush: 'post' },
  );

  onBeforeUnmount(disconnect);

  return width;
}
